export const isStringNullOrEmpty = (text) => {
  return !(text?.length > 0);
};